import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import html2canvas from "html2canvas";
import "./SignatureGenerator.scss";
import { useTranslation } from "react-i18next";
const fonts = [
  "'Dancing Script', cursive",
  "'Pacifico', cursive",
  "'Great Vibes', cursive",
  "'Allura', cursive",
  "'Satisfy', cursive",
];

export default function SignatureGenerator({ onSelectSignature }) {
  const [name, setName] = useState("");
  const [signatures, setSignatures] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const { t } = useTranslation();
  const generateSignatures = () => {
    if (!name.trim()) return;
    const generated = fonts.map((font) => ({
      id: uuidv4(),
      font,
      text: name,
    }));
    setSignatures(generated);
    setSelectedId(null);
  };

  const chooseSignature = async (id) => {
    setSelectedId(id);

    const element = document.getElementById(`signature-container-${id}`);
    if (!element) return;

    // html2canvas capture tout le conteneur (bordure + texte + ID)
    const canvas = await html2canvas(element, {
      backgroundColor: null,
      scale: 3,
    });
    const dataURL = canvas.toDataURL("image/png");
    const selectedSignature = {
      id, // <-- l'ID unique
      dataURL, // <-- l'image générée
    };
    if (onSelectSignature) onSelectSignature(selectedSignature);
  };

  return (
    <div style={{ padding: "20px" }} className="generateur">
      <h3>{t("signature.generateur")}</h3>
      <div className="d-flex mt-3">
        <input
          type="text"
          placeholder={t("signature.entreNom")}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button className={"btn-genere"} onClick={generateSignatures}>
          {t("signature.gener")}
        </button>
      </div>
      <div
        style={{
          display: "flex",
          gap: "20px",
          marginTop: "20px",
          flexWrap: "wrap",
        }}>
        {signatures.map((sig) => {
          const isSelected = selectedId === sig.id;
          return (
            <div
              key={sig.id}
              onClick={() => chooseSignature(sig.id)}
              id={`signature-container-${sig.id}`}
              style={{
                padding: "10px",
                borderTop: isSelected ? "3px solid #007bff" : "1px solid #ccc",
                borderLeft: isSelected ? "3px solid #007bff" : "1px solid #ccc",
                borderRight: isSelected
                  ? "3px solid #007bff"
                  : "1px solid #ccc",
                borderBottom: "none",
                cursor: "pointer",
                textAlign: "center",
                borderRadius: "4px",
              }}>
              <div
                style={{
                  fontFamily: sig.font,
                  fontSize: "32px",
                  marginBottom: "10px",
                }}>
                {sig.text}
              </div>
              <small>ID: {sig.id}</small>
            </div>
          );
        })}
      </div>
    </div>
  );
}
